export const WIDGET_CONTENT_ITEMS_LIST_VISIBLE_COUNT = 3
